export default "__VITE_ASSET__3f2535b7__"